export default __webpack_public_path__ + "static/media/slide9.f3ad07c7.jpg";